import type { ReactNode } from 'react';

import { getSenderInitials } from '../MessageListItem/useMessageListItem';

export type ContactCardProps = {
  name: string;
  /** Position of the contact at the provider, e.g. "Technicien". */
  role?: string | null;
  phones?: (string | null | undefined)[];
  email?: string | null;
  /** Secondary controls (resource menu) pinned to the top-right corner. */
  action?: ReactNode;
  'data-testid'?: string;
};

export type ContactChannel = {
  kind: 'phone' | 'email';
  value: string;
  href: string;
  label: string;
};

const PHONE_HREF_FORBIDDEN_CHARACTERS = /[^\d+]/g;

export function toPhoneHref(phone: string): string {
  return `tel:${phone.replace(PHONE_HREF_FORBIDDEN_CHARACTERS, '')}`;
}

export function getContactChannels(props: Pick<ContactCardProps, 'phones' | 'email'>): ContactChannel[] {
  const phones = (props.phones ?? [])
    .map((phone) => phone?.trim())
    .filter((phone): phone is string => Boolean(phone));

  const channels: ContactChannel[] = phones.map((phone) => ({
    kind: 'phone',
    value: phone,
    href: toPhoneHref(phone),
    label: `Appeler le ${phone}`,
  }));

  const email = props.email?.trim();
  if (email) {
    channels.push({
      kind: 'email',
      value: email,
      href: `mailto:${email}`,
      label: `Écrire à ${email}`,
    });
  }

  return channels;
}

export function useContactCard(props: ContactCardProps) {
  const channels = getContactChannels(props);

  return {
    initials: getSenderInitials(props.name),
    channels,
    hasChannels: channels.length > 0,
  };
}
